<div class="header">
  <div class="header__title">Egnyte Subdomain</div>
  <button class="header__close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="subDomainForm">
  <div class="flex flex-col gt-xs:flex-row mt-2">
    <mat-form-field class="flex-auto">
      <mat-label>Add your subdomain</mat-label>
      <span matPrefix>https://</span>
      <input matInput [formControlName]="'subdomain'" autocomplete="off" required />
      <span matSuffix>.egnyte.com</span>
    </mat-form-field>
  </div>
  <div class="buttons">
    <button class="discard-button" mat-button (click)="discard()" type="button">
      <span>Cancel</span>
    </button>
    <button
      mat-flat-button
      [color]="'primary'"
      [disabled]="subDomainForm.invalid"
      class="send-button"
      type="submit"
      DebounceClick
      (debounceClick)="save()"
    >
      <span *ngIf="!subDomainForm.disabled">Save</span>
      <mat-progress-spinner *ngIf="subDomainForm.disabled" [diameter]="24" [mode]="'indeterminate'">
      </mat-progress-spinner>
    </button>
  </div>
</form>
